import axios from '@_system/axios/axios.js'
export default {
	path: '/flow',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/'+window.config.app+'/system.flow', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},	
	getSonflow(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getSonflow/'+id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getTotalFlowTemplate(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getTotalFlowTemplate', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getSingleFlowTemplate(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getSingleFlowTemplate/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

}
